import React from "react";
import _ from "lodash";
import * as classesImg from "../../styles/communs/image.module.scss";
import {altNN} from "../../utils/parsing";
import dompurify from 'isomorphic-dompurify';

const Image = ({ image, className, color, ariaLabel }) => {
  const useSvg = image?.extension === "svg";
  const isStaticSvg = image?.url;
  const sanitizer = dompurify.sanitize;
  const imageRef = React.createRef();

  React.useEffect(() => {
    if (useSvg) {
      if (color) {
        // override svg color
        _.forEach(document.getElementsByClassName(`${className}`), (el) => {
          el.style.setProperty("--background-color", `${color}`);
        });
      }
      const svg = imageRef?.current?.querySelector("svg");

      if (svg) {
        svg.setAttribute("role", "img");
        svg.setAttribute("name", image?.name);
      }

      const { xMin, xMax, yMin, yMax } = [...svg.children]?.reduce(
        (acc, el) => {
          if (typeof el.getBBox !== "undefined") {
            const { x, y, width, height } = el.getBBox();
            if (!acc.xMin || x < acc.xMin) acc.xMin = x;
            if (!acc.xMax || x + width > acc.xMax) acc.xMax = x + width;
            if (!acc.yMin || y < acc.yMin) acc.yMin = y;
            if (!acc.yMax || y + height > acc.yMax) acc.yMax = y + height;
          } else {
            acc.xMin = 0;
            acc.xMax = 0;
            acc.yMin = 0;
            acc.yMax = 0;
          }

          return acc;
        },

        {}
      );

      const viewbox = `${xMin} ${yMin} ${xMax - xMin} ${yMax - yMin}`;
      svg.setAttribute("viewBox", viewbox);
      svg.setAttribute("height", "100%");
      svg.setAttribute("width", "100%");
    }
  }, [useSvg, imageRef, className, color, image?.name]);

  const alt = image?.alt ? image.alt : ''
  return (
    <>
      {useSvg ? (
        <div
          className={`${className} ${classesImg.svgContainer}`}
          dangerouslySetInnerHTML={{ __html: sanitizer(image?.svgData )}}
          ref={imageRef}
          aria-label={ariaLabel}
        />
      ) : (
        isStaticSvg && <img src={image?.url} alt={altNN(alt)} className={className}/>
      )}
    </>
  );
};

export default Image;
